var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-layout',{attrs:{"page":"404"}},[_c('b-container',{staticClass:"main"},[_c('p',[_vm._v("404!!! Sidan hittades inte! \\(*o*)/ \\(*o*)/ \\(*o*)/")]),_c('p',[_vm._v("Det måste kännas jobbigt nu. Som tröst, lyssna på lite av vår fina körsång:")]),_c('aplayer',{attrs:{"theme":"#599832","music":{
        title: 'Fin är du',
        artist: 'Linnékören',
        src: _vm.imageLink + '2014höst-fin-är-du.wav',
        pic: require('../assets/images/logo.png')
      }}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }